import Vue from 'vue'
import Vuex from "vuex"
import createPersistedState from 'vuex-persistedstate'

import auth from "./auth";
import cover from "./cover";
import breadcrumbs from "./breadcrumbs";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    cover,
    breadcrumbs,
  },
  plugins: [
    createPersistedState({
      key: 'flew',
      paths: ['auth.user', 'auth.office', 'auth.hasUserDetail', 'auth.isClient', 'auth.isOperator', 'auth.isOwner'],
      storage: window.localStorage,
    }),
  ],
});
export default store
